export default __webpack_public_path__ + "static/media/Markers_Dark Blue Marker.f368121c.svg";